export default __webpack_public_path__ + "static/Slide6-8558fe9c3e40c560b0c0b70005c54b85.png";